import styled from 'styled-components';

const EBarAttorneysResultDiv = styled.div`
  width: 100%;
`;

EBarAttorneysResultDiv.displayName = 'EBarAttorneysResultDiv';

export default EBarAttorneysResultDiv;
